/**
 * Core Integration exports
 */

export { initializeCoreIntegration } from './core-module.integration';

